var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1431_3198",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1431_3198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.0863 93.4606C61.8304 93.3773 62.4121 93.121 62.8312 92.6918C63.2512 92.2618 63.4613 91.7439 63.4613 91.1381C63.4613 90.4306 63.2217 89.8827 62.7425 89.4943C62.2625 89.1068 61.6496 88.9548 60.9038 89.0381C57.4871 89.2881 53.67 88.2223 49.4525 85.8406C45.2342 83.4589 42.625 79.4764 41.625 73.8931C41.4583 73.1048 41.1813 72.5152 40.7938 72.1243C40.4054 71.7335 39.9133 71.5381 39.3175 71.5381C38.6633 71.5381 38.1054 71.7831 37.6437 72.2731C37.1829 72.7639 37.0454 73.4964 37.2313 74.4706C38.5196 81.4131 41.7246 86.381 46.8462 89.3743C51.9679 92.3677 56.7146 93.7298 61.0863 93.4606ZM59.9825 104.999C49.9875 104.999 41.6583 101.56 34.995 94.6818C28.3317 87.8043 25 79.2435 25 68.9993C25 61.8202 27.8958 53.8793 33.6875 45.1768C39.4792 36.4752 48.25 26.9289 60 16.5381C71.75 26.9289 80.5208 36.4752 86.3125 45.1768C92.1042 53.8793 95 61.8202 95 68.9993C95 79.2435 91.6625 87.8043 84.9875 94.6818C78.3117 101.56 69.9767 104.999 59.9825 104.999ZM60 99.9993C68.6667 99.9993 75.8333 97.0618 81.5 91.1868C87.1667 85.3118 90 77.916 90 68.9993C90 62.916 87.4792 56.041 82.4375 48.3743C77.3958 40.7077 69.9167 32.3327 60 23.2493C50.0833 32.3327 42.6042 40.7077 37.5625 48.3743C32.5208 56.041 30 62.916 30 68.9993C30 77.916 32.8333 85.3118 38.5 91.1868C44.1667 97.0618 51.3333 99.9993 60 99.9993Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDrop);
export default __webpack_public_path__ + "static/media/water_drop.c5573ebe283d1a2baa3537739628339e.svg";
export { ForwardRef as ReactComponent };